import { GameObject, Game, ComponentChanged, OBSERVER_TYPE } from '@combos-fun/engine';
import type Renderer3D from './Renderer3D';
import type Renderer3DSystem from './system';

export default class Renderer3DManager {
  game: Game;
  rendererSystem: Renderer3DSystem;
  renderers: Renderer3D[] = [];

  constructor({ game, rendererSystem }: { game: Game; rendererSystem: Renderer3DSystem }) {
    this.game = game;
    this.rendererSystem = rendererSystem;
  }

  register(...renderers: Renderer3D[]) {
    for (const renderer of renderers) {
      renderer.game = this.game;
      renderer.rendererManager = this;
      renderer.threeContext = this.rendererSystem.threeContext;
      this.renderers.push(renderer);
    }
  }

  componentChanged(changes: ComponentChanged[]) {
    for (const changed of changes) {
      for (const renderer of this.renderers) {
        const props = renderer.observerInfo[changed.componentName];
        if (!props) continue;

        if (changed.type === OBSERVER_TYPE.ADD || changed.type === OBSERVER_TYPE.REMOVE) {
          try {
            renderer.componentChanged(changed);
          } catch (e) {
            console.error(
              `gameObject: ${changed.gameObject.name}, ${changed.componentName} error.`,
              changed,
              e,
            );
          }
          continue;
        }

        // CHANGE type: check if the changed prop matches
        const index = props.findIndex((prop) => {
          if (typeof prop === 'string' && typeof changed.prop === 'string') {
            return prop === changed.prop;
          }
          // Deep comparison for object-style props
          return JSON.stringify(prop) === JSON.stringify(changed.prop);
        });

        if (index > -1) {
          try {
            renderer.componentChanged(changed);
          } catch (e) {
            console.error(
              `gameObject: ${changed.gameObject?.name}, ${changed.componentName} componentChanged error.`,
              changed,
              e,
            );
          }
        }
      }
    }
  }

  update(gameObject: GameObject) {
    for (const component of gameObject.components) {
      for (const renderer of this.renderers) {
        const props = renderer.observerInfo[component.name];
        if (props) {
          try {
            renderer.rendererUpdate(gameObject);
          } catch (e) {
            console.info(
              `gameObject: ${gameObject.name}, ${component.name} update error`,
              e,
            );
          }
        }
      }
    }
  }
}
